import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const MerchandiseDetailSecondaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3 text-sm font-medium text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})``;

export const MerchandiseDetailPrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const MerchandiseDetailDangerButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-medium text-white transition hover:bg-rose-700",
})``;

export const MerchandiseDetailGridLayout = styled.div.attrs({
  className: "grid gap-5 md:grid-cols-2 xl:grid-cols-4",
})``;

export const MerchandiseDetailGridLayoutSecondary = styled.div.attrs({
  className: "mt-8 grid gap-6 xl:grid-cols-[0.95fr_1.05fr]",
})``;

export const MerchandiseDetailContentStack = styled.div.attrs({ className: "space-y-5" })``;

export const MerchandiseDetailHeroImage = styled(FallbackImage).attrs({
  className: "h-80 w-full rounded-[24px]",
})``;

export const MerchandiseDetailGridLayoutTertiary = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2",
})``;

export const MerchandiseDetailSection = styled.div.attrs({
  className: "brand-panel-muted md:col-span-2",
})``;

export const MerchandiseDetailEyebrowText = styled.p.attrs({
  className: "text-xs uppercase tracking-[0.2em] text-[var(--brand-muted)]",
})``;

export const MerchandiseDetailBodyText = styled.p.attrs({
  className: "mt-3 text-sm leading-7 text-[var(--brand-ink)]",
})``;

export const MerchandiseDetailSectionSecondary = styled.div.attrs({
  className: "brand-panel-muted",
})``;

export const MerchandiseDetailTitleText = styled.p.attrs({
  className: "mt-2 text-lg font-medium text-[var(--brand-ink)]",
})``;

export const MerchandiseDetailGridLayoutQuaternary = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2",
})``;

export const MerchandiseDetailGalleryImage = styled(FallbackImage).attrs({
  className: "h-44 w-full rounded-[22px]",
})``;

export const MerchandiseDetailMetaText = styled.p.attrs({
  className: "text-sm text-[var(--brand-muted)]",
})``;

export const MerchandiseDetailSectionTertiary = styled.div.attrs({ className: "mt-8" })``;

export const MerchandiseDetailInfoRow = styled.div.attrs({
  className: "flex items-center gap-3",
})``;

export const MerchandiseDetailThumbnailImage = styled(FallbackImage).attrs({
  className: "h-12 w-12 rounded-2xl",
})``;

export const MerchandiseDetailLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const MerchandiseDetailMetaTextSecondary = styled.p.attrs({
  className: "text-xs text-[var(--brand-muted)]",
})``;

